import { render, staticRenderFns } from "./FormAbstracts.vue?vue&type=template&id=387c866a&scoped=true"
import script from "./FormAbstracts.vue?vue&type=script&lang=js"
export * from "./FormAbstracts.vue?vue&type=script&lang=js"
import style0 from "./FormAbstracts.vue?vue&type=style&index=0&id=387c866a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c866a",
  null
  
)

export default component.exports